import { isEqual } from 'lodash';

/**
 * Helpful Operator functions
 */
export function isBooleanEqual(a: boolean, b: boolean): boolean {
    return !a === !b;
}

export function isObjectEqual(a: any, b: any): boolean {
    if (a === undefined) {
        a = null;
    }

    if (b === undefined) {
        b = null;
    }

    return isEqual(a, b);
}
